import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { FaCaretDown, FaSignOutAlt, FaKey, FaTimes } from 'react-icons/fa';
import { isStrongPassword, PASSWORD_REQUIREMENTS_MESSAGE } from '../../utils/passwordPolicy';
import toast from 'react-hot-toast';

const Header = ({ title }) => {
    const { user, logout, updatePassword } = useAuth();
    const [showDropdown, setShowDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [changingPassword, setChangingPassword] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (!isStrongPassword(newPassword)) {
            toast.error(PASSWORD_REQUIREMENTS_MESSAGE);
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error('New passwords do not match');
            return;
        }
        setChangingPassword(true);
        const result = await updatePassword(currentPassword, newPassword);
        setChangingPassword(false);
        if (result.success) {
            setShowChangePassword(false);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        }
    };

    return (
        <header className="srm-header">
            <div className="srm-header-left">
                <img 
                    src="/srm-logo.png" 
                    alt="SRMIST Logo" 
                    style={{ 
                        height: isMobile ? '40px' : '60px', 
                        width: 'auto',
                        objectFit: 'contain',
                        backgroundColor: 'white',
                        padding: '4px',
                        borderRadius: '8px'
                    }}
                />
                <div className="srm-header-title">
                    <h1>Attend360</h1>
                    <h2>SRM INSTITUTE OF SCIENCE AND TECHNOLOGY</h2>
                    <h3>DELHI - NCR CAMPUS, GHAZIABAD</h3>
                </div>
            </div>
            <div className="srm-header-right">
                <div className="profile-section" onClick={() => setShowDropdown(!showDropdown)}>
                    <div className="profile-avatar">
                        {user?.name?.charAt(0) || 'U'}
                    </div>
                    <div className="profile-info">
                        <div className="name">{user?.name || 'User'}</div>
                        <div className="role">{user?.role?.toUpperCase() || 'Role'}</div>
                    </div>
                    <FaCaretDown />
                    
                    <div className={`profile-dropdown ${showDropdown ? 'show' : ''}`}>
                        <div className="detail"><strong>Portal:</strong> {user?.role?.toUpperCase()}</div>
                        <div className="detail"><strong>Name:</strong> {user?.name}</div>
                        {user?.regNo && <div className="detail"><strong>Reg No:</strong> {user.regNo}</div>}
                        <div className="detail"><strong>Email:</strong> {user?.email}</div>
                        {user?.contact && <div className="detail"><strong>Contact:</strong> {user.contact}</div>}
                        <button className="logout-btn" style={{ background: '#0a1e3c', marginBottom: '8px' }} onClick={() => { setShowChangePassword(true); setShowDropdown(false); }}>
                            <FaKey /> Change Password
                        </button>
                        <button className="logout-btn" onClick={logout}>
                            <FaSignOutAlt /> Logout
                        </button>
                    </div>
                </div>
            </div>

            {showChangePassword && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 99999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }} onClick={() => setShowChangePassword(false)}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '25px',
                        maxWidth: '420px',
                        width: '100%'
                    }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ color: 'var(--srm-blue)', margin: 0 }}><FaKey /> Change Password</h3>
                            <button onClick={() => setShowChangePassword(false)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>
                                <FaTimes />
                            </button>
                        </div>
                        <form onSubmit={handleChangePassword}>
                            <div className="form-group">
                                <label>Current Password</label>
                                <input type="password" className="form-control" required value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label>New Password</label>
                                <input type="password" className="form-control" required value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                                <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>{PASSWORD_REQUIREMENTS_MESSAGE}</p>
                            </div>
                            <div className="form-group">
                                <label>Confirm New Password</label>
                                <input type="password" className="form-control" required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                                <button type="submit" className="btn btn-success" disabled={changingPassword}>{changingPassword ? 'Updating...' : 'Update Password'}</button>
                                <button type="button" className="btn btn-danger" onClick={() => setShowChangePassword(false)}>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;